/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DemandeInscriptionInvalidationDto
 */
export interface DemandeInscriptionInvalidationDto {
    /**
     * 
     * @type {number}
     * @memberof DemandeInscriptionInvalidationDto
     */
    iddemandeInscription?: number;
    /**
     * 
     * @type {string}
     * @memberof DemandeInscriptionInvalidationDto
     */
    remarqueInvalidation?: string | null;
}

/**
 * Check if a given object implements the DemandeInscriptionInvalidationDto interface.
 */
export function instanceOfDemandeInscriptionInvalidationDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DemandeInscriptionInvalidationDtoFromJSON(json: any): DemandeInscriptionInvalidationDto {
    return DemandeInscriptionInvalidationDtoFromJSONTyped(json, false);
}

export function DemandeInscriptionInvalidationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DemandeInscriptionInvalidationDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'iddemandeInscription': !exists(json, 'iddemandeInscription') ? undefined : json['iddemandeInscription'],
        'remarqueInvalidation': !exists(json, 'remarqueInvalidation') ? undefined : json['remarqueInvalidation'],
    };
}

export function DemandeInscriptionInvalidationDtoToJSON(value?: DemandeInscriptionInvalidationDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'iddemandeInscription': value.iddemandeInscription,
        'remarqueInvalidation': value.remarqueInvalidation,
    };
}

